export const EMAILJS = {
    publicKey: "Bku-8PlEeFmiKR0VJ",
    serviceId: "service_gfllrad",
    templateId: "template_irf5fk7",
  };